<ion-header no-border>
  <ion-toolbar mode="ios">
    <ion-title color="primary"> Schedule Open House </ion-title>

    <ion-button
      class="slim-close-button"
      mode="md"
      (click)="close()"
      slot="start"
      fill="clear"
    >
      <ion-icon name="close-outline" />
    </ion-button>

    <ion-button
      mode="md"
      class="save-btn"
      (click)="saveEvent()"
      [disabled]="!isFormValid()"
      slot="end"
      fill="clear"
    >
      Save
    </ion-button>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="container">
    <!-- Listing address -->
    <div class="border padding item-container">
      <ion-icon name="location-outline" />
      {{ eventData.listingAddress }}
    </div>

    <!-- Date -->
    <div class="border padding item-container">
      <ion-icon name="calendar-outline" />
      <ion-datetime-button datetime="datePicker" />

      <ion-modal [keepContentsMounted]="true">
        <ng-template>
          <ion-datetime
            #date
            (ionChange)="onDateSelected(date)"
            showDefaultButtons="true"
            presentation="date"
            id="datePicker"
            [formatOptions]="{
            date: {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
            },
          }"
          />
        </ng-template>
      </ion-modal>
    </div>

    <!-- Time - @TODO: Replace vaadin with angular material timepicker -->
    <div class="time-container">
      <div class="time">
        <vaadin-time-picker
          id="startTimePicker"
          helper-text="Start time"
          class="timePicker"
          step="3600"
          max="23:00"
        />
      </div>

      <div class="time">
        <vaadin-time-picker
          id="endTimePicker"
          helper-text="End time"
          class="timePicker"
          step="3600"
        />
      </div>
    </div>

    <!-- Assignment -->
    <div class="border padding">
      <h6 class="item-title">Agent Assignment</h6>

      <div class="item-option">
        <ion-checkbox
          value="assign"
          [checked]="assignmentType === 'assign'"
          (ionChange)="onAssignmentTypeChange($event)"
          class="item-option-checkbox"
          mode="ios"
          labelPlacement="end"
          >Assign agent
        </ion-checkbox>

        <div class="item-option-detail">
          <label>Choose a specific agent to handle this event</label>

          <algolia-search-chip-select
            #agentSearch
            [instanceName]="instanceName"
            (onResultClicked)="onResultClick($event)"
          />
        </div>
      </div>

      <div class="item-option">
        <ion-checkbox
          value="claim"
          [checked]="assignmentType === 'claim'"
          (ionChange)="onAssignmentTypeChange($event)"
          class="item-option-checkbox"
          mode="ios"
          labelPlacement="end"
          >Open for agents to <u>claim</u></ion-checkbox
        >

        <div class="item-option-detail">
          <label>The first agent to claim this event will be assigned</label>
        </div>
      </div>

      <div class="item-option">
        <ion-checkbox
          value="request"
          [checked]="assignmentType === 'request'"
          (ionChange)="onAssignmentTypeChange($event)"
          class="item-option-checkbox"
          mode="ios"
          labelPlacement="end"
          >Open for agents to <u>request</u></ion-checkbox
        >

        <div class="item-option-detail">
          @let hasAgentRequests = (eventData.agentRequests || []).length > 0;
          @let isFree = status === OpenhouseEventStatus.free;

          @if (hasAgentRequests) {
            <ul class="agent-request">
              <li *ngFor="let request of eventData.agentRequests">
                <div class="agent-request-item">
                  {{ request.agentName }} &#64; {{ request.requestDate }}
                  @if (!selectedAgent || selectedAgent.objectID !== request.agentId) {
                    <ion-button
                      (click)="approveRequest(request)"
                      class="agent-request-approve-btn"
                      fill="clear"
                      size="small"
                    >
                      Assign
                    </ion-button>
                  }
                </div>
              </li>
            </ul>
          } @else {
            <label>You can review & approve agents requests</label>
          }
        </div>
      </div>
    </div>

    <!-- Advanced options -->
    <ion-accordion-group #accordionGroup (ionChange)="onAdvancedOptionsChange($event)">
      <ion-accordion value="advanced-options">
        <ion-item
          slot="header"
          color="clear"
          class="collapsable-section-title"
          [ngClass]="advancedOptionsVisible ? 'squared-bottom-border' : 'rounded-bottom-border'"
        >
          <ion-label class="subtitle">Advanced Options</ion-label>
        </ion-item>

        <div slot="content" class="ion-padding collapsable-section-content">
          <label class="subtitle">Event Type</label>
          <ion-select
            class="border event-type-select"
            interface="popover"
            value="open-house"
            disabled
            placeholder="Select event type"
            aria-label="Event type"
          >
            <ion-select-option value="open-house">Open House</ion-select-option>
          </ion-select>

          <label class="subtitle">Internal Note</label>
          <label class="description"
            >This note will be shared with assgined agents</label
          >
          <ion-textarea
            maxlength="500"
            [(ngModel)]="eventInternalNote"
            class="border text-area"
            placeholder="Add internal note here..."
            rows="3"
            aria-label="Internal note"
          />
        </div>
      </ion-accordion>
    </ion-accordion-group>

    <div class="btns">
      <ion-button *ngIf="existingEvent" (click)="deleteEvent()">
        Delete
      </ion-button>
    </div>
  </div>
</ion-content>
